import { Badge, BADGE_VARIANTS } from 'ui/badge';

import { WorkflowStatusData } from '../../types';

type WorkflowstatusBadgeProps = {
  workflow: WorkflowStatusData;
};

const displayText = {
  archived: 'Archived',
  enabled: 'Enabled',
  disabled: 'Disabled',
};

export const WorkflowStatusBadge = ({ workflow }: WorkflowstatusBadgeProps) => {
  if (workflow.isArchived) {
    return <Badge variant={BADGE_VARIANTS.FINISHED}>{displayText.archived}</Badge>;
  } else if (workflow.enabled) {
    return <Badge variant={BADGE_VARIANTS.RUNNING}>{displayText.enabled}</Badge>;
  }
  return <Badge variant={BADGE_VARIANTS.DRAFT}>{displayText.disabled}</Badge>;
};
